/**
 * Returns true if the browser supports the WebAuthn API.
 */
export function isWebAuthnSupported(): boolean {
  return typeof window !== 'undefined' && typeof window.PublicKeyCredential !== 'undefined';
}
